<template>
    <div id="dates-overview">
        <div class="dates-overview-row">
            <div class="dates-overview-row-title">
                {{ __('customers.contracts.contract_start_date') }}:
            </div>
            <div class="dates-overview-row-value">
                {{ datesOverview.start_date }}
            </div>
        </div>
        <div class="dates-overview-row">
            <div class="dates-overview-row-title">
                {{ __('customers.contracts.committed_to') }}:
            </div>
            <div class="dates-overview-row-value">
                {{ billedUntilDate }}
            </div>
        </div>
        <div
            v-if="isInvoiceBeforeRenewalEnabled === false"
            class="dates-overview-row"
        >
            <div class="dates-overview-row-title">
                {{ __('customers.contracts.fulfillment_lead_time') }}:
            </div>
            <div class="dates-overview-row-value">
                {{ datesOverview.lead_time }}
            </div>
        </div>
        <div class="dates-overview-row">
            <div class="dates-overview-row-title">
                {{ __('customers.customers.billing_type') }}:
            </div>
            <div class="dates-overview-row-value">
                {{ __(`customers.billing_types.${datesOverview.billing_type}`) }}
            </div>
        </div>
        <div class="dates-overview-row">
            <div class="dates-overview-row-title">
                {{ __('products.products.form.fulfillmentStrategy') }}:
            </div>
            <div class="dates-overview-row-value">
                {{ __(`products.fulfillmentStrategies.values.${datesOverview.fulfillment_strategy}`) }}
            </div>
        </div>
        <div
            v-if="isInvoiceBeforeRenewalEnabled === false"
            class="dates-overview-row mt-3"
        >
            <div class="dates-overview-row-title">
                {{ __('customers.contracts.effective_lead_time') }}:
            </div>
            <div class="dates-overview-row-value">
                {{ datesOverview.effective_lead_time }}
            </div>
        </div>
        <div
            v-if="showFulfillmentDate"
            class="dates-overview-row"
        >
            <div class="dates-overview-row-title">
                {{ __('customers.contracts.fulfillment_start_date') }}:
            </div>
            <div class="dates-overview-row-value">
                {{ fulfillmentStartDate }}
            </div>
        </div>
        <div class="dates-overview-row">
            <div class="dates-overview-row-title">
                {{ __('customers.contracts.invoice_target_date') }}:
            </div>
            <div class="dates-overview-row-value">
                {{ invoiceTargetDate }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DatesOverview',
    props: {
        datesOverview: {
            type: Object,
            default: () => { return {} }
        },
        form: {
            type: Object,
            default: () => { return {} }
        },
        contract: {
            type: Object,
            default: () => { return {} }
        },
        isInvoiceBeforeRenewalEnabled: {
            type: Boolean,
            default: () => false
        }
    },
    computed: {
        billedUntilDate () {
            return this.datesOverview.billed_until_date !== null
                ? this.datesOverview.billed_until_date
                : this.__('customers.contracts.no_billing')
        },
        showFulfillmentDate () {
            return !this.form.existing_contract && (this.contract.id === undefined || this.contract.is_pre_live === true)
        },
        fulfillmentStartDate () {
            switch (this.datesOverview.fulfillment_start_date) {
                case 'after-payment':
                    return this.datesOverview.invoice_target_date !== null
                        ? this.__('customers.contracts.directly_after_payment', {
                            date: this.datesOverview.invoice_target_date
                        })
                        : this.__('customers.contracts.failed_to_determine')
                case 'no-fulfillment-configured':
                    return this.__('customers.contracts.no_fulfillment_configured')
                case 'no-explanation':
                    return this.__('customers.contracts.failed_to_determine')
                default: return this.datesOverview.fulfillment_start_date
            }
        },
        invoiceTargetDate () {
            // If prepaid, we create invoice right away
            if (this.form.prepaid === true) {
                return new Date().toISOString().split('T')[0]
            }
            if (this.datesOverview.invoice_target_date !== null) {
                return this.datesOverview.invoice_target_date
            }

            if (this.datesOverview.excluded_from_invoicing) {
                return this.__('customers.contracts.excluded_from_invoicing')
            }

            if (this.datesOverview.fulfillment_start_date !== null) {
                return this.datesOverview.fulfillment_start_date === 'no-fulfillment-configured'
                    ? this.__('customers.contracts.directly_after_activation')
                    : this.__('customers.contracts.directly_after_fulfillment', {
                        date: this.datesOverview.fulfillment_start_date
                    })
            }

            return this.__('customers.contracts.failed_to_determine')
        }
    }
}
</script>

<style scoped lang="scss">
#dates-overview {
    margin-top: 20px;
    width: 100%;
}

.dates-overview-row {
    width: 100%;
    display: flex;
    line-height: 1.4;
    flex-wrap: wrap;

    &-title {
        font-weight: bold;
        width: 18%;
        padding: 5px;
    }

    &-value {
        width: 82%;
        padding: 5px;
        align-self: center;
    }
}
</style>
